export const BANNER_SECTION_HASH = 'BANNER'

export const BANNER_SECTION_TITLE = 'Banner'
